import { compact } from "lodash";

import { patchVet } from "../../../api/vet/patchVet";
import { useMediaSourceOptions } from "../../../Common/Form/hooks/useMediaSourceOptions";
import { validateRequiredKeys } from "../../../Common/formUtils";
import { useAppDispatch } from "../../../store/service";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { vetSubmitProfileRequestAction } from "../../Actions/RegisterVetActions";
import { useRegistrationContext } from "../Common/registrationContext";
import { saveRegistrationContextToLocalStorage } from "../Common/service";

import { RegistrationReferralFormType } from "./RegistrationReferralFormContext";

export const useValidate = () => {
  const { getHasSelectedReferralOption } = useGetHasSelectedReferralOption();

  const validate = (form: RegistrationReferralFormType) => {
    const requiredKeys: (keyof RegistrationReferralFormType)[] = compact([
      "hearAboutRoo",
      getHasSelectedReferralOption(form.hearAboutRoo) && "referralCode",
    ]);
    const errors = validateRequiredKeys({ form, requiredKeys });
    return errors;
  };

  return { validate };
};

export const useSave = () => {
  const dispatch = useAppDispatch();

  const { registrationContext, setRegistrationContext } = useRegistrationContext();
  const { mediaSourceOptions } = useMediaSourceOptions();

  const { userId, entityId, zipcode } = registrationContext;

  const save = async (form: RegistrationReferralFormType): Promise<void> => {
    const newRegistrationContext = {
      ...registrationContext,
      ...form,
    };

    setRegistrationContext({
      registrationContext: newRegistrationContext,
    });

    await patchVet({
      userId: registrationContext.userId,
      vetId: registrationContext.entityId,
      hearAboutRoo: form.hearAboutRoo,
      referralCode: form.referralCode,
      zipcode,
    });

    EventTracker.send({
      eventName: Event.Name.VET_CLICK_SOURCE,
      eventType: Event.Type.CLICK,
      entityType: Event.Entity.VET,
      entityId: registrationContext.entityId,
      context: {
        hearAboutRoo: form.hearAboutRoo,
        label: mediaSourceOptions.find((option) => option.value === form.hearAboutRoo)?.label,
      },
    });

    // Mark registration as completed.
    saveRegistrationContextToLocalStorage(newRegistrationContext);
    dispatch(vetSubmitProfileRequestAction({ vetRegistrationPageNo: 5, userId, vetId: entityId }));
  };

  return { save };
};

export const useGetHasSelectedReferralOption = () => {
  const { referralOptionId } = useMediaSourceOptions();
  const getHasSelectedReferralOption = (hearAboutRoo?: number) => referralOptionId === hearAboutRoo;

  return { getHasSelectedReferralOption };
};
